module.exports = __webpack_public_path__ + "img/mc.b4f4b90d.svg";